import { saveAs } from 'file-saver';

export const toBase64 = file =>
    new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });

function base64ToFile(base64String, filename, contentType) {
    const sliceSize = 512;
    const byteCharacters = atob(base64String);
    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);
        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
    }
    return new File(byteArrays, filename, { type: contentType });
}

export function downloadBase64File(contentType, base64Data, fileName) {
    const file = base64ToFile(base64Data, fileName, contentType);
    return saveAs(file, fileName);
}

export function downloadFile(fileName, blob) {
    const downloadLink = document.createElement('a');
    downloadLink.href = URL.createObjectURL(blob);
    downloadLink.download = fileName;
    downloadLink.hidden = true;
    downloadLink.click();
}



// WEBPACK FOOTER //
// ./src/lib/file.utils.js